function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as t } from "./index.es33.js";
import { t as u } from "./index.es106.js";
import { clsx as e } from "./index.es105.js";
import { Typography as a } from "./index.es35.js";
import { palette as b } from "./index.es36.js";
import { Icon as i } from "./index.es7.js";
import { monthTranslationKeys as x } from "./index.es529.js";
import o from "./index.es530.js";
import n from "./index.es527.js";

var g = function g(_ref) {
  var m = _ref.setViewDate,
      h = _ref.setSecondaryMode,
      d = _ref.setPrimaryMode,
      s = _ref.secondViewDate,
      r = _ref.secondaryMode,
      l = _ref.primaryMode,
      c = _ref.viewDate;
  return t.jsxs("div", {
    className: o.header,
    children: [t.jsxs("div", {
      className: n.headSection,
      children: [t.jsx(a.Body1, {
        as: "button",
        className: e(o.button, o.withIcon, n.calendarControlButton),
        onClick: function onClick() {
          return m(new Date(new Date(s).setMonth(s.getMonth() - 1)));
        },
        children: t.jsx(i, {
          color: b.gray10,
          size: 16,
          icon: i.icons.outline.backArrow
        })
      }), t.jsxs("div", {
        className: e(n.headSectionPicker, n.calendarHeadSectionPicker),
        children: [t.jsx(a.Body1, {
          as: "button",
          className: e(o.button, n.calendarControlButton, _defineProperty({}, o.buttonSelected, r === "months")),
          onClick: function onClick() {
            return h(r === "months" ? "dates" : "months");
          },
          children: u(x[Intl.DateTimeFormat("en", {
            month: "short"
          }).format(s)])
        }), t.jsx(a.Body1, {
          as: "button",
          className: e(o.button, n.calendarControlButton, _defineProperty({}, o.buttonSelected, r === "years")),
          onClick: function onClick() {
            return h(r === "years" ? "dates" : "years");
          },
          children: s.getFullYear()
        })]
      })]
    }), t.jsxs("div", {
      className: n.headSection,
      children: [t.jsxs("div", {
        className: e(n.headSectionPicker, n.calendarHeadSectionPicker),
        children: [t.jsx(a.Body1, {
          as: "button",
          className: e(o.button, n.calendarControlButton, _defineProperty({}, o.buttonSelected, l === "months")),
          onClick: function onClick() {
            return d(l === "months" ? "dates" : "months");
          },
          children: u(x[Intl.DateTimeFormat("en", {
            month: "short"
          }).format(c)])
        }), t.jsx(a.Body1, {
          as: "button",
          className: e(o.button, n.calendarControlButton, _defineProperty({}, o.buttonSelected, l === "years")),
          onClick: function onClick() {
            return d(l === "years" ? "dates" : "years");
          },
          children: c.getFullYear()
        })]
      }), t.jsx(a.Body1, {
        as: "button",
        className: e(o.button, o.withIcon, n.calendarControlButton),
        onClick: function onClick() {
          return m(new Date(new Date(c).setMonth(c.getMonth() + 1)));
        },
        children: t.jsx(i, {
          color: b.gray10,
          size: 16,
          icon: i.icons.outline.forwardArrow
        })
      })]
    })]
  });
};

export { g as RangeHeader };